import { generateKeyBetween, generateNKeysBetween } from 'fractional-indexing';

/**
 * Sortierschlüssel (Fractional Indexing), übernommen aus KaBa. Jedes sortierbare Element trägt einen String,
 * der Byte für Byte sortiert wird (Spalte in PostgreSQL mit `COLLATE "C"`). Ein Verschieben ändert im
 * Normalfall nur den Schlüssel des bewegten Elements.
 */
export function keyBetween(before: string | null | undefined, after: string | null | undefined): string {
  const a = before ?? null;
  const b = after ?? null;
  if (a !== null && b !== null && a >= b) throw new PositionCollisionError(a, b);
  return generateKeyBetween(a, b);
}

export function keysBetween(before: string | null, after: string | null, n: number): string[] {
  return generateNKeysBetween(before, after, n);
}

/** Gleichzeitige Einfügungen an derselben Stelle: Aufrufer muss die Nachbarn neu lesen oder neu verteilen. */
export class PositionCollisionError extends Error {
  constructor(
    public readonly before: string,
    public readonly after: string,
  ) {
    super(`Positionskollision: ${before} >= ${after}`);
  }
}

/** Sortiert nach Position, bei Gleichstand stabil nach ID (Byte-Vergleich wie `COLLATE "C"`). */
export function byPosition<T extends { position: string; id: string }>(a: T, b: T): number {
  if (a.position < b.position) return -1;
  if (a.position > b.position) return 1;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
